export default __webpack_public_path__ + "71bbe3d5fd486127b83d2f9405b12602.jpg";